export const insuranceCompanies = [
    {
        value: "Aetna",
        label: "Aetna"
    }, {
        value: "Kaiser Permanente",
        label: "Kaiser Permanente"
    }, {
        value: "Elevance Health (Anthem)",
        label: "Elevance Health (Anthem)"
    }, {
        value: "UnitedHealth",
        label: "UnitedHealth"
    }, {
        value: "Guidewell (Florida Blue)",
        label: "GuideWell (Florida Blue)"
    }, {
        value: "Blue Cross Blue Shield",
        label: "Blue Cross Blue Shield"
    }, {
        value: "Humana",
        label: "Humana"
    }]
